import { WorldCreator } from "./WorldCreator";
import { World } from "./World";
import styles from "./WorldsArea.module.css";

export function WorldsArea({
  onSelectWorld,
  onCreateWorld,
  worlds,
  currentWorld,
}) {
  return (
    <section className={styles.worldsArea}>
      <WorldCreator onCreateWorld={onCreateWorld} />
      <div className={styles.worldsCarousel} aria-label="World selector">
        <div className={styles.worldsList}>
          {worlds.map((world) => (
            <World
              worldData={world}
              onSelectWorld={onSelectWorld}
              key={world.id}
              isActive={world.id === currentWorld}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
